import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { ActivityReservationPageProps } from "@b2bportal/core-activities";
import { activitiesPostBookingApi } from "@b2bportal/core-activities";
import {
  ActivityBookingStatus,
  ItineraryState,
} from "@b2bportal/rbc-activities-api";

export const useActivityReservationPage = (
  context: ActivityReservationPageProps["context"]
) => {
  const singleItinerary = context.activityReservation;
  const reservation = singleItinerary?.reservation;

  const allReservations = useSelector(
    activitiesPostBookingApi.endpoints.fetchAllActivityReservations.select()
  );

  const isActiveBooking = useMemo(() => {
    if (!reservation) return false;

    const activityStatus = reservation.activityStatus;
    const pastBookings =
      allReservations?.data?.itineraries?.[ItineraryState.Past] ?? [];
    const isPast = pastBookings.some(
      (booking) =>
        booking.reservation.customerReservationId ===
        reservation.customerReservationId
    );

    if (
      activityStatus === ActivityBookingStatus.Cancelled ||
      activityStatus === ActivityBookingStatus.Pending ||
      isPast
    ) {
      return false;
    }

    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allReservations?.data?.itineraries?.[ItineraryState.Past], reservation]);

  const isLoading =
    context.isLoading || singleItinerary == null || reservation == null;

  return {
    singleItinerary,
    reservation,
    isLoading,
    isActiveBooking,
  };
};
